<template>
  <div class="container">
    
      <div class="container text m-t-1-sm m-b-3-sm m-y-2-md">
      <h1 class="titulo m-t-2 m-t-3-md">Biomasa</h1>

      <hr>

      <h3>¿A qué nos referimos con biomasa?</h3>
      
      <p>La biomasa es todo material orgánico que proviene de un proceso biológico, contemplando como materia prima a las plantas, los animales, sus derivados y desechos. Por su parte, la bioenergía es obtenida mediante la transformación de la biomasa en biocombustibles, que pueden ser sólidos (ejemplo: leña y pellets), líquidos (ejemplo: etanol y biodiesel) o gaseosos (ejemplo: biogás). Las diferentes opciones de producción y aprovechamiento de la biomasa permiten obtener distintos usos finales, como la calefacción y/o cocción (energía térmica), generación de electricidad (energía eléctrica) y los biocombustibles líquidos para el transporte, permitiendo sustituir fuentes energéticas fósiles en diversas aplicaciones de todos los sectores económicos.</p>

      <p>El interés en la biomasa se basa en su naturaleza renovable, ya que, si se maneja sustentablemente en todo el ciclo de vida, las opciones bioenergéticas producen un menor impacto ambiental respecto a los combustibles fósiles y son una alternativa de mitigación al cambio climático global. Por lo tanto, el papel de la biomasa en la transición energética es clave en la estrategia de descarbonizar la economía global.  Otras ventajas de la biomasa incluyen, ser una fuente energética de carácter local, generar más empleos por unidad de energía entregada que otras opciones renovables, tener una gran diversidad de aplicaciones, ser escalable, flexibilidad en su almacenamiento y uso según la demanda, brindando un respaldo a las fuentes intermitentes como la solar o eólica. La mayoría de las tecnologías bioenergéticas son actualmente comerciales y en muchos casos, más económicas que las opciones convencionales.</p>

      <p>De acuerdo con su origen, la biomasa puede clasificarse en: I) Primaria: considerando a toda la biomasa derivada directamente de la fotosíntesis; II) Residual: es la derivada de transformaciones por medio de actividades con algún tipo de intervención humana. A continuación, se muestran las estimaciones del potencial biomásico que consideran principalmente la biomasa residual del sector agrícola y forestal, destacando los siguientes puntos:</p>

      <p>a) En la siguiente figura se compara el potencial de biomasa forestal total, procedente de modelos del incremento medio anual, con la demanda de leña en los sectores residencial e industrial. </p>
      <p>b) El potencial teórico disminuye 44% cuando se consideran restricciones de acceso, resultando en un potencial técnico máximo de 58.6 MtMS/año. La demanda se estima en 20.7 MtMS/año, quedando aproximadamente 38 MtMS/año disponible para otros usos. </p>
      <p>c) Debido a los diferentes usos que tiene y que puede tener la biomasa forestal, es importante impulsar un mercado regulado que permita planificar el uso energético de la biomasa a mediano y largo plazo.</p>
      
      </div>

      <div class="container">

        <img src="@/assets/img/planeas/biomasa/biomasa_principal.jpg" class="img-center"/>

        <div id="graficaBiomasa"></div>
        
        
      </div>


      <div class="contenedor-referencias-bibliograficas container text m-t-1-sm m-b-3-sm m-y-2-md">
        <div class="encabezado"><h2>Referencias bibliográficas</h2></div>
        <ul class="lista-referencias">
          <li><em><strong>Cluster de biocombustibles sólidos (CBCS). Plataforma geoespacial para la planeación bioenergética (2018).</strong></em> Recuperado en enero 2023. <a href="https://wegp.unam.mx/cemie/Mexico#" target="_blank">https://wegp.unam.mx/cemie/Mexico#</a></li>
          <li><em><strong>Tauro, R., Serrano-Medrano, M., Masera, O. (2018).</strong></em> Solid biofuels in Mexico: a sustainable alternative to satisfy the increasing demand for heat and power. Clean Technologies and Environmental Policy. ISSN: 1618-9558. DOI-: 10.1007/s10098-018-1529-z- (SCI: IF 2.3).</li>
          <li><em><strong>Instituto Nacional de Estadística y Geografía (INEGI). (2015)</strong></em> Modelo de Elevación Digital (MDE) 15m. Recuperado de <a href="https://www.inegi.org.mx" target="_blank">https://www.inegi.org.mx</a></li>
          <li><em><strong>Instituto Nacional de Estadística y Geografía (INEGI). (2017)</strong></em> Carta de Uso del Uso de Suelo y Vegetación, Serie VI. Recuperado de <a href="https://www.inegi.org.mx" target="_blank">https://www.inegi.org.mx</a></li>
          <li><em><strong>Comisión Nacional para el Conocimiento y Uso de la Biodiversidad (CONABIO) SEMARNAT-CONANP; Áreas Naturales Protegidas Federales de México. (2020).</strong></em> Recuperado de <a href="http://geoportal.conabio.gob.mx/metadatos/doc/html/anpnov17gw.html" target="_blank">http://geoportal.conabio.gob.mx/metadatos/doc/html/anpnov17gw.html</a></li>
          <li><em><strong>Serrano-Medrano, M., Arias-Chalico, T., Ghilardi, A., & Masera, O. (2014).</strong></em> Spatial and temporal projection of fuelwood and charcoal consumption in Mexico. Energy for Sustainable Development, 19, 39–46. https://doi.org/10.1016/j.esd.2013.11.007</li>
        </ul>            
      </div>

  </div>
</template>
<script>

  import * as d3 from 'd3';

  export default {
    name: 'App',
    components: {
      
    },
    data: function () {
      return {
          
      }   
    },
    mounted() {
     
      


    },
    beforeDestroy() {
     
    },
  }

</script>
<style scoped lang="scss">

  .graficaBiomasa
  {
    position: relative;
    top: -400px;
    width: 100%;
    height: 300px;
  }

</style>
